import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceCenterTabComponent } from './resource-center-tab.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { ResourceCenterContentModule } from '../resource-center-content/resource-center-content.module';

@NgModule({
  declarations: [ResourceCenterTabComponent],
  imports: [CommonModule, ResourceCenterContentModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        TabResourceCenter: {
          component: ResourceCenterTabComponent,
        },
      },
    }),
  ],
})
export class ResourceCenterTabModule {}
